import { Component, OnInit } from '@angular/core';
import { AppConstant } from '../app.constants';
import { LoaderService } from '../shared/services/loader.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {

  constructor(public _appConstant: AppConstant, private _loaderService: LoaderService) { }

  ngOnInit() {
    console.log("das Init");
    this._loaderService.display(false);
    if (this._appConstant.userDetail)
      this._appConstant.ShowAdminDashboard = this._appConstant.userDetail.roleContext == this._appConstant.roleContext.Admin && this._appConstant.logInAsProgramContext == false;
  }
}
